import React from 'react';
import { StyleSheet, View } from 'react-native';

import LoaderLottieJSON from '@/assets/animations/loader.json';
import { ds } from '@/components/lib/design.system';
import LottieView from 'lottie-react-native';

// The loader.json canvas is 300x150, but the visible spinner icon is only ~66px wide/tall
// and centered, leaving large transparent margins. We scale the canvas so the *visible* icon
// matches the requested `size`, then clip the layout box to `size` so the loader occupies the
// same footprint as the default spinner (no button height shift).
const CANVAS_WIDTH = 300;
const CANVAS_HEIGHT = 150;
const ICON_SIZE = 66;

// The animation's two layers are both named for color targeting via colorFilters.
const LAYER_KEYPATHS = ['icon', 'icon 2'];

export interface LottieLoaderProps {
    /** Target visible diameter of the loader (matches the default spinner's size). */
    size?: number;
    /** Color applied to the loader strokes. Defaults to white. */
    color?: string;
}

export const LottieLoader = ({
    size = 24,
    color = ds.colorValue.icon.primary,
}: LottieLoaderProps): React.JSX.Element => {
    const scale = size / ICON_SIZE;
    const lottieWidth = CANVAS_WIDTH * scale;
    const lottieHeight = CANVAS_HEIGHT * scale;

    const colorFilters = LAYER_KEYPATHS.map(keypath => ({ keypath, color }));

    return (
        <View style={[styles.container, { width: size, height: size }]}>
            <LottieView
                source={LoaderLottieJSON}
                style={{ width: lottieWidth, height: lottieHeight }}
                webStyle={{ width: lottieWidth, height: lottieHeight }}
                colorFilters={colorFilters}
                resizeMode={'contain'}
                autoPlay
                loop
            />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    },
});
